module.exports = __webpack_public_path__ + "img/database-lock-gray.d577e3aa.svg";